import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Footer() {
  return (
    <MDBox width="100%" display="flex" justifyContent="center" alignItems="center" px={1.5} py={2}>
      <MDTypography variant="caption" color="text">
        &copy; {new Date().getFullYear()} Pet Realm Admin
      </MDTypography>
    </MDBox>
  );
}

export default Footer;
